import { fullName } from "./user_utils";
export const displayName = (comment) => {
  if (comment.display_name) {
    return comment.display_name;
  } else {
    return fullName(comment.user);
  }
};
